var amdi18n={"__root":{"select_identity_attributes":"Select identity attributes","select_cloud_identity_attributes":"Select attributes for Cloud Identity","insert_pin":"Insert PIN for Cloud Identity","transmit_identity_attributes":"Transmit data","create_cloud_identity":"Create Cloud Identity"},"__de":{"select_identity_attributes":"Identitätsattribute auswählen","select_cloud_identity_attributes":"Attribute für Cloud Identität auswählen","insert_pin":"PIN für Cloud Identität eingeben","transmit_identity_attributes":"Daten übertragen","create_cloud_identity":"Cloud Identität erzeugen"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/state/nls/AttributesSelectionState_strings.js
// module id = 326
// module chunks = 3